  /*============Find A Dealer Form Controller
  ================================*/
  angular
      .module('vppApp')
      .controller('findDealerResultsController', findDealerResultsController);

  findDealerResultsController.$inject = ['$scope', '$window', '$http', '$state', 'FindDealerResultsService', '$stateParams', 'vppConfig', 'googleMapsFactory'];

    function findDealerResultsController($scope, $window, $http, $state, FindDealerResultsService, $routeParams, vppConfig, googleMapsFactory){
      // console.log('findDealerResultsController()');
      // console.log('googleMaps', googleMapsFactory);
      // console.log('results:', FindDealerResultsService.get());

      var mapData = {
        map: null,
        location: null,
        markers: []
      };

      // var results;
      var serviceData = FindDealerResultsService.get();

      $scope.showAllDealers = false;
      $scope.showByInt = 5;
      $scope.startRange = 0;
      $scope.resultGroups = [];
      $scope.activeGroup = 0;
      $scope.currentItems = [];

      // $scope.resultsRange = {min: 0, max: 4};
      $scope.mapInit = serviceData['mapInit'];
      $scope.results = serviceData['dealerResultsVO'];

      // $scope.toggleShowAll = function() {
      $scope.toggleShowAll = function() {
        $scope.showAllDealers = !$scope.showAllDealers;
        $scope.updateShowAll();
      };
      $scope.updateShowAll = function() {
        // $scope.showAllDealers;
        // console.log('updateShowAll()', $scope.showAllDealers);
        $scope.resultGroups = [];
        $scope.showByInt = !$scope.showAllDealers ? 5 : 999999; //$scope.results.length;

        console.log('$scope.showByInt: ', $scope.showByInt, 'showAll', $scope.showAllDealers);

        //update groups
        for(var i = 0; i < $scope.results.length; i++) {
          var group = Math.floor((i+1) / $scope.showByInt);
          // console.log('group: ', group, ", i", i);

          if(!$scope.resultGroups[group]) {
            $scope.resultGroups[group] = [];
          }
          $scope.resultGroups[group].push(i);
        }

        $scope.updateMarkersGroup(0);
      };

      $scope.updateMarkersGroup = function(group) {
        // $scope.startRange = startIndex;
        $scope.activeGroup = group;
        showLocationRange({min: $scope.resultGroups[group][0], max: $scope.resultGroups[group][$scope.resultGroups[group].length - 1] });
      };

      var init = function() {

        adjustHeight($window.document.querySelectorAll('.makeItFit'));

        angular.element($window).bind('resize', function() {
          adjustHeight($window.document.querySelectorAll('.makeItFit'));
        });

        mapData.map = new google.maps.Map($window.document.getElementById('map'), {
          center: mapData.location, //$scope.mapInit.zip, //$scope.findIt.position,
          zoom: 13
        });

        $scope.updateShowAll();
        // console.log('groups: ', $scope.resultGroups);

        // addMarker('You', mapData.location);
        // showLocationRange({min: $scope.startRange, max: $scope.startRange + $scope.showByInt - 1});
      };

      var showLocationRange = function(range) {
        // mapData.map.clearMarkers
        deleteMarkers();

        for(var i = range.min; i <= range.max; i++) {
          if(i < $scope.results.length) {
            var item = $scope.results[i],
                num = i + 1;
            // console.log('result', item);

            var marker = addMarker('test' + i.toString(),
                {
                  lat: parseFloat(item.latitude),
                  lng: parseFloat(item.longitude)
                },
                i + 1
                /*{
                  text: num.toString(),
                  color: 'white'
                }*/
            );
            // parse phone numbers
            item.parsedPhone = {};
            var phoneLen = item.phone.length;
            for (var j = 0; j < phoneLen; j++) {
              switch(item.phone[j].type) {
                case 'dealerMain':
                  item.parsedPhone.dealerMain = item.phone[j].number;
                  break;
                case 'dealerFax':
                  item.parsedPhone.dealerFax = item.phone[j].number;
                  break;
              }
            }
            // $scope.results[i].index = num;
            // var result = $scope.results[i];
            var result = item;
            result.index = num;
            $scope.currentItems.push(result);
          }
        }
        resizeMap();
      };

      var resizeMap = function () {
        var center = mapData.map.getCenter();
        google.maps.event.trigger(mapData.map, 'resize');
        mapData.map.setCenter(center);
        // if(mapData.markers.length > 1) {
          fitBounds();
        // }
      };

      var adjustHeight = function(elements) {
        var windowHeight = $window.innerHeight || $window.document.documentElement.clientHeight || $window.document.getElementsByTagName('body')[0].clientHeight,
            windowWidth = $window.innerWidth || $window.document.documentElement.clientWidth || $window.document.getElementsByTagName('body')[0].clientWidth,
            heightSize;

        if (windowWidth >= 600) { // || $scope.findIt.showPlaces === false) {
          heightSize = windowHeight - 48 - 38;
        } else {
          heightSize = (windowHeight - 48 - 38)/2;
        }

        for (var i = 0; i < elements.length; i++) {
          angular.element(elements[i]).css('height', heightSize + 'px');
        }
      };

      var fitBounds = function() {

        if(mapData.markers.length == 1) {
          // console.log('setCenter', mapData.markers[0].position.lat());
          mapData.map.setCenter(
              {
                lat: parseFloat(mapData.markers[0].position.lat()),
                lng: parseFloat(mapData.markers[0].position.lng())
              }
          );

        } else {
          var bounds = new google.maps.LatLngBounds();
          for (var i = 0; i < mapData.markers.length; i++) {
            bounds.extend(mapData.markers[i].getPosition());
          }
          mapData.map.fitBounds(bounds);
        }

        // console.log('fitBounds()', bounds.getNorthEast(), bounds.getSouthWest());

      };

      // Sets the map on all markers in the array.
      function setMapOnAll(map) {
        for (var i = 0; i < mapData.markers.length; i++) {
          mapData.markers[i].setMap(map);
        }
      }

      // Removes the markers from the map, but keeps them in the array.
      function clearMarkers() {
        setMapOnAll(null);
      }

      // Shows any markers currently in the array.
      function showMarkers() {
        setMapOnAll(map);
      }

      // Deletes all markers in the array by removing references to them.
      function deleteMarkers() {
        clearMarkers();
        mapData.markers = [];
        $scope.currentItems = [];
      }


      var addMarker = function (title, position, num) {
        // console.log('addMarker', position.lat, position.lng, label);
        var image = {
          url: './content/img/global/map/map_location_icon-' + num + '.png',
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(13, 70),
          size: new google.maps.Size(100, 166),
          scaledSize: new google.maps.Size(25, 42)

        };

        var marker = new google.maps.Marker({
          position: position,
          map: mapData.map,
          // title: title,
          icon: image
          // label: label
        });
        mapData.markers.push(marker);
        return marker;
      };

      // figure out a zip code for the map location
      if(!$scope.mapInit.zip || $scope.mapInit.zip == '') {
        if($scope.results.length > 0) {
          $scope.mapInit.zip = $scope.results[0].postalCode.substr(0, 5);
        } else {
          console.error('NO RESULTS RETURNED FOR LOCATION');
        }
      }

      // console.log('using zip', $scope.mapInit.zip);

      // get latlng from zip and then init the map
      if($scope.results.length > 0) {
        googleMapsFactory.zipToLocation($scope.mapInit.zip).then(function (location) {
          // console.log('location', location);
          mapData.location = location;
          init();
        });
      }

  };
